import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=5c9ed0b0&"
import script from "./payment.vue?vue&type=script&lang=js&"
export * from "./payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c9ed0b0')) {
      api.createRecord('5c9ed0b0', component.options)
    } else {
      api.reload('5c9ed0b0', component.options)
    }
    module.hot.accept("./payment.vue?vue&type=template&id=5c9ed0b0&", function () {
      api.rerender('5c9ed0b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/vehicle-registration/payment.vue"
export default component.exports